<template>
    <div class="webFooter">
        <div :style="this.$route.path=='/home' ? 'dispaly:block':'display:none'" class="footer-main">
            <div class="wrap cont">
                <div class="main-cooperation">
                    <h1>我们期待与您合作</h1>
                    <div class="txt-s" style="margin-right:60px;">盛大天地运营，构建创业苗圃、孵化器、加速器等创新型企业办公及人才公寓和商娱配套等空间集群，是国内领先的科创园区资产管理解决方案提供商。</div>
                    <div class="main-contact">
                        <div class="msg">
                            <div class="tel">
                                <img src="../assets/images/web/tel-ico.png"/>
                                <span>021-38586888</span>
                            </div>
                            <div class="addr">
                                <div><Icon type="md-mail" />cooperation@shandaworld.cn </div>
                                <div><Icon type="md-pin" />中国（上海）自由贸易试验区盛荣路88弄</div>
                            </div>
                        </div>
                        <div class="line"></div>
                        <div class="ecode">
                            <div>
                                <p>服务号</p>
                                <img src="../assets/images/web/ico-fuwu.jpg"/>
                            </div>
                            <div>
                                <p>订阅号</p>
                                <img src="../assets/images/web/ico-dingyue.jpg"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-link">
                    <h3>友情链接</h3>
                    <ul>
                        <li :key="item.id" v-for="item in linkList">
                            <a href="" @click="showDetail(item)">{{item.title}}</a>
                        </li>
                        <!-- <li>源创谷</li>
                        <li>盛贸中心</li>
                        <li>盛大中国</li>
                        <li>源创谷</li>
                        <li>盛贸中心</li>
                        <li>盛创中心</li>
                        <li>青春里公寓</li> -->
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-copy">
            <div class="wrap">
                沪ICP备18023895号-4
                <span class="space-line">|</span><a @click="modal1 = true">隐私政策</a>
                <span class="space-line">|</span><a @click="modal2 = true">法律声明</a>
            </div>
        </div>
        <Modal
                v-model="modal1"
                title="隐私政策"
                class-name="vertical-center-modal"
                fullscreen
        >
            <div class="modal-cont" >
                <h2>隐私政策</h2>
                <p>感谢您访问盛大天地运营（“盛大天地”“我们”、“本公司”或“我们的”）网站。我们致力于保护本网站（“本网站”）访问者的隐私及安全。请仔细阅读本隐私政策（“隐私政策”），了解我们一般如何收集您的个人身份信息，以及我们可能如何使用和披露该等个人信息。当您于本网站向我们提供您的个人信息后即表示您已充分阅读、理解并接受本隐私政策的全部内容。</p>
                <p>本隐私政策是本网站使用条款（“使用条款”）的一部分并纳入该条款，该使用条款约束您对本网站的使用。在使用本网站前，请先阅读使用条款。</p>
                <p>使用本网站或提供任何个人信息即表示同意本隐私政策。如果您（以及您的委托人）不同意所有使用条款（包括本政策），请不要使用本网站或提供信息（或允许他人代表您这么做）。</p>
                <p>本网站还可能提供第三方网站的链接供您参考。一旦您访问这些第三方网站的链接，您将会离开本网站。这些第三方网站的隐私政策可能与我们的隐私政策不同。本隐私政策不适用于您向任何第三方提供的个人信息。我们不监控或控制第三方网站所收集的信息或任何第三方的隐私政策，也不对任何第三方网站的隐私政策或内容承担任何责任。</p>
                <h2>信息收集</h2>
                <p>我们可能会通过您自愿提交的内容来收集信息。是否提供个人信息，如姓名、电话号码、邮寄地址、电子邮件地址、公司行业、租赁需求或其他有关您本人的个人身份信息（“个人信息”），始终是您或您的任何代理人的选择。不过，为了获得我们提供的某些材料和服务以及使用网站的某些功能，您将需要为我们提供关于您本人的个人信息。因此，决定不提供这些信息将限制或取消您获得某些材料或使用网站某些功能的能力。</p>
                <p>我们还会使用 cookie，以便更好地了解访问者如何使用我们的网站，从而继续改进它。我们可能会收集以下信息：您用于互联网接入的域名和主机；您的起始网站的互联网地址；访问的日期和时间；您的计算机的 IP 地址以及有关操作系统、浏览器和主机的信息；您访问本网站的日期和时间以及访问的页面。如果您不想接收 cookie，可以将浏览器设置为拒绝 cookie。但是，如果关闭 cookie，您可能无法访问本网站的某些服务和功能。</p>
                <h2>信息的使用和披露</h2>
                <p>
                    一般来说，我们会使用在本网站收集的信息来完成我们的任务，并从事信息收集的目标活动。具体来说，我们会将您的信息用于：<br/>
                    – 与您联系、沟通我们的使命、操作、服务和活动； – 向您发送与我们的活动及/或服务有关的通知、信息； – 分析访问者反馈和跟踪网站使用数据，以改进本网站和其他内部用途；– 数据合并、数据存储、客户信息管理、报告和其它内部用途；– 遵守法律或真诚相信该等行为是遵守法律规定或遵循要求本公司履行的法律程序所必需的；和/或 – 征得您的同意的其他活动。</p>>

                   <p> 除下列情况外，我们不会与其他组织共享或以其他方式披露任何个人信息：<br/>
                       – 仅出于您提供个人信息的目的或我们在您提供个人信息时披露的任何其他目的，向关联公司、员工、合作伙伴、承包商或代理共享或披露； – 与国家安全、国防安全、公共利益直接相关；– 遵循任何法院命令、法律或政府部门要求； – 与内部或外部审计相关；或 – 征得您的同意。</p>

                <p> 当您希望本网站停止收集、使用您的个人信息，您可通过cooperation@shandaworld.cn联系我们。</p>
                <h2>隐私政策变更</h2>
                <p>请注意，本隐私政策可能会在未来发生变更。在我们变更本隐私政策后，如您继续使用本网站，即被视为接受这些变更，因此请检查本网站的这一部分是否有任何修改，如果您不同意更新后的隐私政策内容，请不要使用本网站或提供信息（或允许他人代表您这么做）。</p>
                <h2>联系方式</h2>
                <p>如果您对本隐私政策、本网站的做法或使用有任何疑问，可通过cooperation@shandaworld.cn联系我们。 </p>
                <h2>隐私政策的效力</h2>
                <p>本隐私政策自2022年8月17日起生效</p>
            </div>
        </Modal>
        <Modal
                title="法律声明"
                v-model="modal2"
                fullscreen
                class-name="vertical-center-modal">
            <div class="modal-cont" >
            <h2>使用条款</h2>
            <p>感谢您访问盛大天地运营（“盛大天地”、“我们”、“本公司”或“我们的”）网站。请注意，以下使用条款（“使用条款”）以及我们的隐私政策（“隐私政策”）适用于您对本公司网站（“本网站”）的使用，包括本公司网站提供的所有内容和功能。</p>
            <p>如果您（以及您的委托人）不同意所有使用条款，请不要使用本网站或提供信息（或允许他人代表您这么做）。</p>
            <p>访问或使用本网站即表示您同意本使用条款，包括但不限于不时修订的隐私政策。在我们做出更改后继续使用本网站将被视为接受这些更改，因此请定期检查更新。</p>
            <h2>内容所有权</h2>
            <p>网站中包含或展示的所有的内容，包括但不限于所有文本、图形、照片、图片、视频和其他材料（“内容”）以及该等内容的选择、协调和排列均归我们、我们的许可方或该等材料的其他提供商（统称我们的“内容提供商”）所有，并且受版权、商标、专利和其他知识产权或所有权法律保护。我们保留所有未明确授予的权利。</p>

            <h2>内容的使用</h2>
            <p>网站中的内容受版权法保护。除版权法或本使用条款明确许可外，未经我们的内容提供商明确许可和同意，不得复制、分发、修改、盗用、存储或传输任何内容或将其整合到其他网站。未经本公司及内容供应商明确许可，不得在任何情况下出售内容或将其用于任何商业目的。

             <h2>注册及服务</h2>
            <p>要访问网站的某些区域，可能需要完成注册流程、预约服务或创建帐户。在注册、预约服务或创建帐户时，您必须提供准确、完整的信息。您对帐号的安全使用负全部责任。您必须为您的用户名和密码保密，不允许任何人使用您的用户名和密码。</p>

            <p>我们在注册流程、预约服务或创建帐户过程中收集的个人身份信息将受隐私政策制约。</p>

            <h2>指向其他资源的链接</h2>
            <p>本网站所载由第三方提供的指向其他网站和资源的链接仅为方便您而提供，并不表示本公司认可这些内容。我们无法控制这些网站或资源的内容，您同意我们对您使用这些网站或资源可能造成的任何损失或损害不承担任何责任。</p>

            <h2>网站的不当使用</h2>
            <p>您同意不执行以下操作：(a) 以任何违反任何适用法律或法规的方式使用本网站；(b) 从事任何使本网站或任何人使用或享受本网站的权利丧失、负担过重、受损、削弱、限制或受到干扰，或者可能损害盛大或本网站用户或使其承担责任的行为；(c) 引入对网站有恶意或者技术危害的病毒、木马、蠕虫、逻辑炸弹或者其他材料；(d) 将弹出窗口置于网站页面上，或以其他方式影响网站页面的显示；(e) 出于违反本使用条款的任何目的，使用任何自动设备、流程或手段访问本网站。此外，您同意不跟踪、骚扰或伤害他人，不冒充任何人员或实体，或以其他方式歪曲您与他人或实体的联系，或收集或存储关于本网站其他用户或访问者的个人数据。</p>

            <h2>赔偿</h2>
            <p>对于我们任何一方或内容提供商因使用本网站或与其相关，或您违反或被指违反本条款而产生的任何索赔、损害或损失招致的任何和所有损失、损害、责任以及各种性质的成本，您同意为我们和我们的内容提供商提供赔偿、辩护，使其免受伤害。您同意充分配合对上述任何内容的辩护。
            </p>
            <h2>不作担保</h2>
            <p>盛大及其任何关联公司均不对网站或内容的完整性、安全性、可靠性、质量、准确性或可用性作任何担保或声明。本网站内所有内容仅作参考信息，无论何种情形下，均不可认定为任何承诺或要约。</p>

            <p>网站和所有内容（无论由谁生成）以及本网站提供的所有服务都会发生更改。我们或我们的内容提供商“按原样”提供，不提供任何担保或条件，不承担任何类型的明示或默示的责任，包括但不限于任何（如果有）针对适销性和特定用途适合性的担保或条件。</p>

            <h2>责任限制</h2>
            <p>在法律允许的最大范围内，您同意我们或我们的任何内容提供商对您或任何其他人承担任何特殊、间接、偶然或惩罚性损害、利润损失、隐私或安全损失、声誉损失、未能履行任何义务等损害或任何其他类似损害不承担任何责任。</p>

            <h2>终止</h2>
            <p>我们保留随时终止您对本网站的任何或全部使用，或者终止或取消本协议的权利，无需事先通知。您同意我们无需对终止您或任何第三方对本网站的访问承担任何责任。</p>

            <h2>其他</h2>
            <p>本使用条款包含隐私协议，构成您与我们就本网站达成的完整协议。我方未能主张某一权利或规定，不构成对该权利或规定的放弃。如果本使用条款的任何规定被认定无效、非法或不可强制执行，则该规定应被取消或限制在最低范围内，以使本使用条款的其他规定继续完全有效。与本网站和本使用条款有关的所有事项均应受中华人民共和国法律管辖，并根据中华人民共和国法律进行解释，任何与法律规定冲突的选择或内容均视为无效。</p>

            <p>如果您对本使用条款、本网站的做法或使用有任何疑问，可通过cooperation@shandaworld.cn 联系我们。</p>

            <p>本使用条款自 2022 年8月17日起生效</p>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {
              linkList:[],
                modal1: false,
                modal2: false,
            }

        },
        methods: {
            getLinks() {
                this.loading = true;
                this.$http.get("/api/services/app/CommonWeb/GetContentsByNodeName?nodeName=友情链接")
                    .then(res => {
                        this.linkList = res.data.result;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            showDetail(result){
               window.open(result.source);
            }
        },
        mounted() {
          this.getLinks();
        },
    }
</script>

<style lang="less">
    .ivu-modal-body{
        padding:0 !important;
        .modal-cont{
            width: 1200px;
            padding:20px 30px;
            margin:0 auto;
            background-color: #f5f5f5;
            h2{
                font-size: 18px;
                margin-top:10px;
                margin-bottom:5px;
            }
            h2:first-child{
                margin-top:0;
            }
            p{
                line-height: 1.6;
            }
        }
    }
    .ivu-modal-header{
        width:1200px;
        margin:0 auto;
    }
    .ivu-modal-footer{

    }
    .webFooter{
        font-size:14px;
        .wrap{
            width: 1170px;
            margin: 0 auto;
        }
        .footer-main{
            background-color: #242933;
            text-align: left;
            .cont{
                display: flex;
                flex-flow: row;
                color:#fff;
                padding-top:60px;
                .main-cooperation{
                    width:60%;
                    h1{
                        font-size:36px;
                    }
                    .txt-s{
                        padding-top:10px;
                    }
                    .main-contact{
                        padding-top:60px;
                        padding-bottom:35px;
                        display: flex;
                        flex-flow: row;
                        align-items: center;
                        justify-content: space-between;
                        *{

                        }
                        .msg{
                            .tel{
                                display: flex;
                                flex-flow: row;
                                align-items: center;
                                justify-items: center;
                                img{
                                    width:34px;
                                    height:30px;
                                }
                                span{
                                    font-size:32px;
                                    padding-left:28px;
                                    line-height: 1;
                                    font-weight: bold;
                                }
                            }
                            .addr{
                                padding-top: 30px;
                                .ivu-icon{
                                    font-size:16px;
                                    color:#3172E5;
                                    padding-right:10px;
                                }
                                *{
                                    line-height: 1.6;
                                }
                            }
                        }
                        .line{
                            height:56px;
                            width:3px;
                            background:#2F3541;

                        }
                        .ecode{
                            display: flex;
                            flex-flow: row;
                            align-items: center;
                            text-align: center;
                            padding-right:30px;
                            p{
                                padding-bottom:10px;
                            }
                            *{
                                width:70px;
                                margin-right:30px;
                            }
                        }
                    }
                }
                .main-link{
                    width:40%;
                    position: relative;
                    z-index:100;
                    /*background: url("../assets/images/web/footer-bg.png") bottom center no-repeat;*/
                    h3{
                        text-align: left;

                    }
                    ul{
                        padding-top:20px;
                        display: flex;
                        flex-flow: row;
                        align-items: center;
                        flex-wrap: wrap;
                        position: relative;
                        z-index: 1000;
                        li{
                            width:50%;
                            text-align: left;
                            /*line-height: 1.6;*/
                            padding-bottom:10px;
                            list-style: none;
                            a{
                                color:#fff;
                                padding-left: 5px;
                                display: inline-block;
                            }
                        }
                        li:before {
                            content: "";
                            display: inline-block;
                            width: 4px;
                            height: 4px;
                            background-color: #fff;
                            border-radius: 50%;
                            margin-right:0;
                            vertical-align: middle;
                        }
                        li:hover{
                            cursor: pointer;
                            color:#66CFF2;
                            position: relative;
                            z-index: 1000;
                        }
                    }
                    ul:hover{
                       li:hover{
                           cursor: pointer;
                           color:#66CFF2;
                           a{
                               color:#66CFF2;
                           }
                       }
                    }
                }
                .main-link::before{
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: 0;  /*放在内容背后*/
                    width: 500px;
                    height: 300px;
                    background: url("../assets/images/web/footer-bg.png") bottom center no-repeat;
                    background-size: 90% 50%;
                    opacity: 0.3;  /*透明度*/
                }
            }
        }
        .footer-copy{
            background-color: #2E2F30;
            color:#fff;
            text-align: left;
            text-transform: uppercase;
            height: 50px;
            line-height: 50px;
            .space-line{
                padding:0 10px;
            }
        }
    }
    .vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal{
            top: 0;
            /*height: 80%;*/
            /*overflow-y: scroll;*/
        }
    }
</style>